export class FeitoConferidoAction {

  id: string;
  name: string;

  public static get INSERT() {
    return {id: 'INSERT', name: 'Inclusão'};
  }

  public static get UPDATE() {
    return {id: 'UPDATE', name: 'Atualização'};
  }

  public static get DELETE() {
    return {id: 'DELETE', name: 'Exclusão'};
  }

  public static get FILE_IMPORT() {
    return {id: 'FILE_IMPORT', name: 'Importação de arquivo'};
  }


  public static fromString(name: string){
    const value = (this as any)[name];
    if (value) {
      return value;
    }
    throw new RangeError(
        `Illegal argument passed to fromString(): ${name} does not correspond to any instance of the enum ${
            (this as any).prototype.constructor.name
        }`
    );

  }

  public static get getTiposAction() {
    return [
      this.INSERT,
      this.UPDATE,
      this.DELETE,
      this.FILE_IMPORT
    ].sort( (a1, a2) => a1.name.localeCompare(a2.name));
  }
}
